// 🟢 new
export const canonicalRole = (r) => {
  const raw = String(r || '').trim();
  const key = raw.toLowerCase();

  const map = {
    superadmin: 'superadmin',
    super_admin: 'superadmin',
    superadminrole: 'superadmin',
    titanadmin: 'titanAdmin',
    titan_admin: 'titanAdmin',
    admin: 'admin',
    company: 'company',
    student: 'student',
    donatoruser: 'donatorUser',
    donator: 'donatorUser',
  };

  return map[key] || raw; // fallback to raw if already canonical
};

export const isAdminType = (role) =>
  ['titanAdmin', 'superadmin'].includes(canonicalRole(role));

const roleRank = (role) =>
  ({
    donatorUser: 1,
    student: 1,
    company: 1,
    admin: 2,
    titanAdmin: 3,
    superadmin: 4,
  }[canonicalRole(role)] || 0);

export const canManageUser = (actorRole, targetRole) => {
  const a = roleRank(actorRole);
  const t = roleRank(targetRole);

  if (a === 0 || t === 0) return false;     // ✅ unknown roles -> deny
  if (a <= t) return false;                 // ✅ cannot manage equal/higher
  return true;                              // ✅ only higher can manage lower
};
